import React from 'react';
import { Text } from '@eo-locale/react';
import { classes } from '@guest-widgets/shared/src/classes';
import { getWeekend } from '@guest-widgets/shared/src/utils/dates/dates';

import { ChipsContainer, Chip, StyledChipProps } from '../Chip';
import { DateRange, datesAreEqual } from '../../../filters';

const today = new Date();
today.setHours(0, 0, 0, 0);
const tomorrow = new Date(today);
tomorrow.setDate(tomorrow.getDate() + 1);
const weekend = getWeekend(today);

export interface DateChipsProps {
  dates?: DateRange;
  onSelect: (dates?: DateRange) => void;
}

const DateChip = (props: StyledChipProps) => (
  <Chip className={classes.catalog.filters.dates.chip} variant="outlined" clickable {...props} />
);

export const DateChips = ({ dates, onSelect }: DateChipsProps) => {
  const [from, to] = dates || [];

  return (
    <ChipsContainer>
      <DateChip
        isActive={!from}
        label={<Text id="product-catalog.filters.date.all" />}
        onClick={() => onSelect()}
      />
      <DateChip
        isActive={datesAreEqual(from, today) && datesAreEqual(to, today)}
        label={<Text id="product-catalog.filters.date.today" />}
        onClick={() => onSelect([today, today])}
      />
      <DateChip
        isActive={datesAreEqual(from, tomorrow) && datesAreEqual(to, tomorrow)}
        label={<Text id="product-catalog.filters.date.tomorrow" />}
        onClick={() => onSelect([tomorrow, tomorrow])}
      />
      <DateChip
        isActive={datesAreEqual(from, weekend[0]) && datesAreEqual(to, weekend[1])}
        label={<Text id="product-catalog.filters.date.weekend" />}
        onClick={() => onSelect(weekend)}
      />
    </ChipsContainer>
  );
};
